import styled from '@emotion/styled'

const FILE_NAME_MAX_WIDTH = 300

export const FileNameWrapper = styled.div`
  max-width: ${FILE_NAME_MAX_WIDTH}px;
  white-space: nowrap;
`
